"use strict";var e=require("react");exports.useMountedState=()=>{const r=e.useRef(!1),t=e.useCallback((()=>r.current),[]);return e.useEffect((()=>(r.current=!0,()=>{r.current=!1})),[]),t};
//# sourceMappingURL=useMountedState.js.map
